module.exports = __webpack_public_path__ + "static/media/stackoverflow.8914cb44.svg";